<template>
    <div style="position:relative"
         v-bind:class="getCSSClass('edit-form-container')"
    >
        <div v-if="!loaded" v-html="loadingIndicator" :class="getCSSClass('edit-form-loading-indicator')"></div>
        <div v-if="loaded && (typeof(formTitle != 'undefined'))"
             v-bind:class="getCSSClass('edit-form-form-title-container')"
        ><h4 v-html="formTitle"></h4></div>
        <div v-if="formDisabled" class="disabled-overlay"></div>
        <form role="form"  v-on:submit.prevent="submitForm"  v-if="loaded"
              v-bind:class="getCSSClass('edit-form-form')"
        >
            <div v-if="!formDisabled"
                 v-bind:class="getCSSClass('edit-form-form-buttons-container') + getCSSClass('edit-form-form-start-buttons-container')"
            >
                <div :class="getCSSClass('edit-form-form-buttons-container')">

                    <div :class="getCSSClass('edit-form-save-buttons-container')">
                        <span v-if="loading" style="margin-right: .5rem" :class="getCSSClass('button-loading-indicator')" v-html="loadingIndicator"></span>
                        <button type="button"
                                v-if="buttons['save_and_close']"
                                v-bind:class="getCSSClass('model-manager-save_and_close-button')"
                                v-on:click="submitForm"
                                v-bind:disabled="loading"
                                style="display: flex; align-items: center; justify-content: center"
                        >

                            <span v-if="currentStep != lastStep" v-html="buttons['proceed']['html']"></span>
                            <span v-if="currentStep == lastStep && buttons['save_and_close']" v-html="buttons['save_and_close']['html']"></span>
                        </button>
                        <button v-if="currentStep == lastStep && buttons['save_without_closing']"
                                type="button"
                                v-bind:class="getCSSClass('model-manager-save_without_closing-button')"
                                v-on:click="submitForm(false)"
                                v-bind:disabled="loading"
                                style="display: flex; align-items: center; justify-content: center; margin-left: .5rem"
                        >
                            <span v-if="currentStep == lastStep" v-html="buttons['save_without_closing']['html']"></span>
                        </button>
                    </div>
                </div>
                <div :class="getCSSClass('edit-form-cancel-button-container')">

                    <button type="button"
                            v-bind:class="getCSSClass('model-manager-cancel-button')"
                            v-on:click="cancelEditing"
                            v-html="buttons['cancel']['html']"
                    ></button>
                </div>
                <div v-if="validationErrorMessage != ''"
                     style="width: 100%; padding-top: .5rem; padding-bottom: .5rem; text-align: left; padding-left: 1rem; color: red"
                     v-html="validationErrorMessage"
                ></div>
            </div>
            <div v-for="step in stepsToRender"
                 :key="'step-'+step.toString()"
                 v-bind:class="getCSSClass('edit-form-step')"
            >
                <div v-if="typeof(config.stepLabels[step]) != 'undefined'"
                     v-bind:class="formHeadClass(step)"
                     v-html="config.stepLabels[step]"></div>
                <section v-for="group in groups[step]"
                         v-bind:class="groups[step].length > 1 ? getCSSClass('edit-form-group') : ''"
                         :key="'step-group-'+group"
                         style="width: 100%"
                >
                    <div v-if="groups[step].length > 1"
                         v-on:click="toggleGroupVisibility(group)"
                         v-bind:class="getCSSClass('edit-form-group-head')"
                         style="display: flex; align-items: center; justify-content: space-between; cursor:pointer"
                    >
                        <span v-html="group"></span>
                        <span class="vuecrud-caret"
                              v-html="icon('caret-left')"
                              v-bind:class="{'open': openGroups.includes(group)}"></span>
                    </div>
                    <section v-bind:class="groupSectionClass(step)"
                             v-show="groups[step].length  == 1 || (groups[step].length > 1 && openGroups.includes(group))"
                             style="width: 100%">
                        <div style="position:relative"
                             :data-group="group"
                             v-bind:class="getCSSClass('edit-form-step-body', 'edit-form-step-body')"
                        >
                            <div v-if="currentStep != step" class="disabled-overlay"></div>
                            <div v-for="data, fieldname in stepSubjectDataForGroup(subjectDataForStep(step), group)"
                                 :data-group="group"
                                 :key="'step-group-container-'+fieldname"
                                 v-bind:style="formContainerStyle(data, fieldname)"
                                 v-bind:class="data.containerClass">
                                <template v-if="!shouldHideField(fieldname)">
                                    <label v-if="data.label != null">
                                        {{ data.label }}
                                        <span v-if="data.mandatory"> *</span>
                                        <span :class="getCSSClass('edit-form-label-tooltip')" v-if="typeof(data.helpTooltip) != 'undefined'" v-html="data.helpTooltip"></span>
                                        <span v-if="errorExists(fieldname)" :class="getCSSClass('editform-validation-error-label-message')" v-html="errors[fieldname][0]"></span>
                                    </label>
                                    <div v-if="data.kind == 'color'"
                                         style="display: flex; align-items:center; justify-content: center">
                                        <input class="form-control"
                                               type="text"
                                               v-bind:value="subjectData[fieldname].value">
                                        <input class="form-control" type="color"
                                               v-model="subjectData[fieldname].value"
                                               style="width: 3em; padding: 0px"
                                        >
                                    </div>
                                    <input v-if="data.kind == 'input' && data.type != 'password'  && data.type != 'number'"
                                           v-model="subjectData[fieldname].value"
                                           v-bind:placeholder="subjectData[fieldname].placeholder"
                                           v-bind:class="data.class"
                                           v-bind:list="Object.keys(subjectData[fieldname].valueset).length > 0 ? fieldname+'-lookup' : null"
                                           type="text"
                                    >
                                    <datalist v-if="data.kind == 'input' && data.type != 'password'  && data.type != 'number' && Object.keys(subjectData[fieldname].valueset).length > 0"
                                              v-bind:id="fieldname+'-lookup'"
                                    >
                                        <option v-for="valuesetvalue, valuesetitem in data.valueset"
                                                v-bind:value="valuesetvalue"
                                        ></option>
                                    </datalist>
                                    <input v-if="data.kind == 'input' && data.type == 'number'"
                                           v-model="subjectData[fieldname].value"
                                           type="number"
                                           v-bind:placeholder="subjectData[fieldname].placeholder"
                                           v-bind:class="data.class"
                                           v-bind:min="numberFieldMin(fieldname)"
                                           v-bind:max="numberFieldMax(fieldname)"
                                           v-bind:step="numberFieldStep(fieldname)"
                                    >
                                    <div v-if="data.kind == 'slug'">
                                        <input v-model="subjectData[fieldname].value"
                                               v-bind:class="data.class"
                                               style="padding-right: 1.5em; display: inline-block; width: 90%">
                                        <span style="margin-left: -1.5em; cursor:pointer"
                                              v-on:click="generateSlug(data.customOptions['source'], fieldname)"
                                        >↺</span>
                                    </div>
                                    <input v-if="data.kind == 'input' && data.type == 'password'"
                                           v-model="subjectData[fieldname].value"
                                           v-bind:placeholder="subjectData[fieldname].placeholder"
                                           v-bind:class="data.class"
                                           type="password"
                                    >
                                    <input v-if="data.kind == 'input' && data.type == 'date'"
                                           v-model="subjectData[fieldname].value"
                                           v-bind:placeholder="subjectData[fieldname].placeholder"
                                           v-bind:class="data.class"
                                           type="date"
                                    >
                                    <number-field v-if="data.kind == 'numberfield'"
                                                  editable="true"
                                                  :input-class="getCSSClass('editform-numberfield-input-class')"
                                                  show-currency-label="true"
                                                  :container-class="''"
                                                  v-model="subjectData[fieldname].value"
                                                  v-bind="JSON.parse(data.props)"
                                    ></number-field>

                                    <textarea v-if="data.kind == 'text' && data.type == 'simple'"
                                              v-model="subjectData[fieldname].value"
                                              v-bind:placeholder="subjectData[fieldname].placeholder"
                                              v-bind:class="data.class"
                                    ></textarea>
                                    <div v-if="data.kind == 'text' && data.type == 'static'"
                                    >
                                        <div v-html="subjectData[fieldname].staticValue"></div>
                                        <input v-bind:value="subjectData[fieldname].value" type="hidden">
                                        <label v-if="subjectData[fieldname].customOptions['visible']" v-html="subjectData[fieldname].value"></label>
                                    </div>
                                    <div v-if="data.kind == 'text' && data.type == 'richtext-trix'" v-bind:class="data.class" style="min-height:95%; height:95%; margin-bottom: 2em">
                                        <trix-wrapper v-model="subjectData[fieldname].value"
                                                      v-bind:fieldname="fieldname"
                                                      v-bind="JSON.parse(data.props)"
                                                      v-bind:ajax-operations-url="ajaxOperationsUrl"
                                        ></trix-wrapper>
                                    </div>
                                    <div v-if="data.kind == 'text' && data.type == 'richtext-quill'" v-bind:class="data.class" style="min-height:95%; height:95%; margin-bottom: 2em">
                                        <quill-wrapper v-model="subjectData[fieldname].value"
                                                       v-bind:fieldname="fieldname"
                                                       v-bind="JSON.parse(data.props)"
                                                       v-bind:ajax-operations-url="ajaxOperationsUrl"
                                        ></quill-wrapper>
                                    </div>
                                    <div v-if="data.kind == 'text' && data.type == 'richtext-tinymce'" v-bind:class="data.class" style="min-height:95%; height:95%; margin-bottom: 2em">
                                        <tiny-mce-wrapper v-model="subjectData[fieldname].value"
                                                          v-bind:fieldname="fieldname"
                                                          v-bind="JSON.parse(data.props)"
                                                          v-bind:ajax-operations-url="ajaxOperationsUrl"
                                        ></tiny-mce-wrapper>
                                    </div>
                                    <select v-if="data.kind == 'select' && (data.type == null || data.type == 'yesno' || data.type == 'custom')"
                                            v-model="subjectData[fieldname].value"
                                            v-bind:style="subjectData[fieldname].value == -1 ? {'color': 'lightgray'} : {}"
                                            v-bind:class="data.class"
                                    >
                                        <option v-for="valuesetvalue, valuesetitem in data.valuesetSorted"
                                                v-bind:value="valuesetvalue"
                                                v-bind:style="valuesetvalue == -1 ? {'color': 'lightgray'} : {'color': 'black'}"
                                                v-html="valuesetitem">
                                        </option>
                                    </select>
                                    <select-or-add-field v-if="data.kind == 'select' && data.type == 'select-or-add-field'"
                                                         v-bind="JSON.parse(data.props)"
                                                         v-model="subjectData[fieldname].value"
                                    ></select-or-add-field>
                                    <datepicker v-if="data.kind == 'datepicker'"
                                                v-bind="JSON.parse(data.props)"
                                                v-model="subjectData[fieldname].value"
                                                :locale="locale"
                                    ></datepicker>
                                    <image-picker v-if="data.kind == 'imagepicker'"
                                                  v-bind="JSON.parse(data.props)"
                                                  v-model="subjectData[fieldname].value"
                                                  v-bind:upload-url="ajaxOperationsUrl"
                                                  :key="fieldname"
                                                  :fieldname="fieldname"
                                    ></image-picker>
                                    <span v-if="data.kind == 'radio'">
                                    <p v-for="valuesetvalue, valuesetitem in data.valuesetSorted">
                                        <input
                                                type="radio"
                                                v-model="subjectData[fieldname].value"
                                                :id="fieldname+'_'+valuesetvalue"
                                                :key="fieldname+'_'+valuesetvalue"
                                                :value="valuesetvalue">
                                        <label :for="fieldname+'_'+valuesetvalue" v-html="valuesetitem">
                                        </label>
                                    </p>
                                </span>
                                    <span v-if="data.kind == 'checkbox'">
                                    <p v-for="valuesetvalue, valuesetitem in data.valuesetSorted">
                                        <input
                                                type="checkbox"
                                                v-model="subjectData[fieldname].value[valuesetvalue]"
                                                :id="fieldname+'_'+valuesetvalue"
                                                :key="fieldname+'_'+valuesetvalue"
                                                :value="valuesetvalue">
                                        <label :for="fieldname+'_'+valuesetvalue" v-html="valuesetitem">
                                        </label>
                                    </p>
                                </span>
                                    <multi-select v-if="data.kind == 'vue-multiselect'"
                                                  v-bind="JSON.parse(data.props)"
                                                  :valueset="data.valuesetSorted"
                                                  v-model="subjectData[fieldname].value"
                                    ></multi-select>
                                    <searchable-select v-if="data.kind == 'searchable-select'"
                                                       v-bind="JSON.parse(data.props)"
                                                       :valueset="data.valuesetSorted"
                                                       v-model="subjectData[fieldname].value"
                                    ></searchable-select>
                                    <treeselect v-if="data.kind == 'vue-treeselect'"
                                                v-bind="JSON.parse(data.props)"
                                                :options="data.valuesetSorted"
                                                v-model="subjectData[fieldname].value"
                                    ></treeselect>
                                    <component v-if="data.kind == 'custom-component'"
                                               v-bind:is="data.type"
                                               v-bind="JSON.parse(data.props)"
                                               v-model="subjectData[fieldname].value"
                                               v-bind:errors="componentError(fieldname)"
                                               :buttons="buttons"
                                    ></component>
                                    <select v-if="data.kind == 'multiselect'"
                                            style="height: 200px; min-height: 200px"
                                            class="form-control"
                                            v-bind:class="data.class"
                                            multiple="multiple"
                                            v-model="subjectData[fieldname].value"
                                    >
                                        <option v-for="valuesetvalue, valuesetitem in data.valuesetSorted"
                                                v-bind:value="valuesetvalue" v-html="valuesetitem"
                                        ></option>
                                    </select>
                                    <recaptcha-component v-if="data.kind == 'recaptcha'"
                                                         :g-key="JSON.parse(data.props).key"
                                                         v-model="subjectData[fieldname].value">

                                    </recaptcha-component>
                                </template>
                            </div>
                        </div>
                    </section>
                </section>
            </div>
        </form>
        <div :class="getCSSClass('editform-nonform-errors-container')" v-if="nonFormErrorKeys.length > 0">
            <div :class="getCSSClass('editform-nonform-error')"
                 v-for="key in nonFormErrorKeys" v-html="errors[key][0]"></div>
        </div>
        <div :class="getCSSClass('editform-result-message-container')" v-if="resultMessage != ''">
            <div v-bind:class="getCSSClass('editform-result-message')+' '+resultMessageClass"
                 v-html="resultMessage"></div>
        </div>
        <div v-if="!formDisabled"
             v-bind:class="getCSSClass('edit-form-form-buttons-container') + getCSSClass('edit-form-form-end-buttons-container')"
        >
            <div v-if="validationErrorMessage != ''"
                 :class="getCSSClass('editform-validation-error-message')"
                 v-html="validationErrorMessage"
            ></div>

            <div :class="getCSSClass('edit-form-form-button-container')"
            >
                <div :class="getCSSClass('edit-form-save-buttons-container')">
                    <span v-if="loading" style="margin-right: 4px" class="button-loading-indicator" v-html="loadingIndicator"></span>
                    <button type="button"
                            v-if="buttons['save_and_close']"
                            v-bind:class="getCSSClass('model-manager-save_and_close-button')"
                            v-on:click="submitForm"
                            v-bind:disabled="loading"
                            style="display: flex; align-items: center; justify-content: center"
                    >
                        <span v-if="currentStep != lastStep" v-html="buttons['proceed']['html']"></span>
                        <span v-if="currentStep == lastStep && buttons['save_and_close']" v-html="buttons['save_and_close']['html']"></span>
                    </button>
                    <button v-if="currentStep == lastStep && buttons['save_without_closing']"
                            type="button"
                            v-bind:class="getCSSClass('model-manager-save_without_closing-button')"
                            v-on:click="submitForm(false)"
                            v-bind:disabled="loading"
                            style="display: flex; align-items: center; justify-content: center; margin-left: .5rem"
                    >
                        <span v-if="currentStep == lastStep" v-html="buttons['save_without_closing']['html']"></span>
                    </button>
                </div>
            </div>
            <div v-bind:class="getCSSClass('edit-form-cancel-button-container')"
            >
                <button type="button"
                        v-bind:class="getCSSClass('model-manager-cancel-button')"
                        v-on:click="cancelEditing"
                        v-html="buttons['cancel']['html']"
                ></button>
            </div>
        </div>
    </div>
</template>

<script>
    import {translateMixin} from './mixins/translateMixin.js'
    export default {
        inject: ['getCSSClass', 'loadingIndicator', 'icon', 'locale'],
        mixins: [translateMixin],
        props: {
            dataUrl: {type: String},
            saveUrl: {type: String},
            ajaxOperationsUrl: {type: String, default: ''},
            successCallback: {type: String},
            formTitle: {type: String},
            showResponseMessage: {type: Boolean, default: false},
            redirectToResponseOnSuccess: {type: String},
            redirectToOnCancel: {type: String},
            buttons: {type: Object, default: () => {
                    return {
                        'save': {'class': 'btn-outline-primary', 'html': 'Save'},
                        'cancel': {'class': 'btn-outline-secondary', 'html': 'Cancel'},
                    }
                }},
            formDisabled: {type: Boolean, default: false},
            extraUrlParameters: {type: Object, default: () => {return {}}}
        },
        data: function() {
            return {
                subjectData: {},
                errors: {},
                loaded: false,
                resultMessage: '',
                dirty: false,
                loading: false,
                config: {},
                currentStep: -1,
                resultMessageClass: '',
                groups: [],
                openGroups: [],
            }
        },
        mounted() {
            this.getFormData();
        },
        computed: {
            stepsToRender: function() {
                return this.config.steps.filter((step) => {
                    return step <= this.currentStep;
                })
            },
            groupsToRender: function() {

            },
            lastStep: function() {
                if (typeof(this.config['steps']) != 'undefined') {
                    return this.config.steps.length > 0
                        ? this.config.steps[this.config.steps.length - 1]
                        : -1;
                }
            },
            formdata: function() {
                let result = {};
                for (let key in this.subjectData) {
                    if (this.subjectData.hasOwnProperty(key)) {
                        if (this.subjectData[key].type == 'text') {
                            result[key] = this.subjectData[key].value == null
                                ? ''
                                : this.subjectData[key].value.toString();
                        } else {
                            result[key] = this.subjectData[key].value;
                        }
                    }
                }
                result['respondWith'] = this.redirectToResponseOnSuccess == 'true'
                    ? 'url'
                    : 'subject';
                result['currentStep'] = this.currentStep;

                return result;
            },
            rootShowInPlaceEditor: function() {
                return this.$root.showInPlaceEditor;
            },
            parentShowInPlaceEditor: function() {
                return this.$parent.showInPlaceEditor;
            },
            stepConditionData: function() {
                let result = {};
                for (var i in this.subjectData) {
                    if ((this.subjectData.hasOwnProperty(i)) && (this.config.conditionFields.indexOf(i) > -1)) {
                        result[i] = this.subjectData[i].value;
                    }
                }

                return result;
            },
            nonFormErrorKeys: function() {
                return Object.keys(this.errors).filter((key) => {
                    return typeof(this.subjectData[key]) == 'undefined';
                });
            },
            validationErrorMessage: function() {
                return Object.keys(this.errors).length > 0
                    ? this.translate('There were errors saving the data, please review the form and try again')
                    : '';
            }
        },
        methods: {
            groupSectionClass: function(step) {
                if (this.groups[step].length > 1) {
                    return this.getCSSClass('edit-form-group-section');
                }
                return '';
            },
            formContainerStyle: function(data, fieldname) {
                let result = {
                    height: typeof(data.customOptions['cssHeight']) == 'undefined' ? 'auto' : data.customOptions['cssHeight']
                }
                if (this.shouldHideField(fieldname)) {
                    result['padding'] = '0';
                }

                return result;
            },
            formHeadClass: function(step) {
                if (this.currentStep == step) {
                    return this.getCSSClass('edit-form-step-head')
                } else {
                    return this.getCSSClass('edit-form-step-head-inactive')
                }
            },
            numberFieldMin: function(fieldname) {
                if ((typeof(this.subjectData[fieldname]) != 'undefined')
                    && (typeof(this.subjectData[fieldname].customOptions['min']) != 'undefined')) {
                    return this.subjectData[fieldname].customOptions['min'];
                }
                return false;
            },
            numberFieldMax: function(fieldname) {
                if ((typeof(this.subjectData[fieldname]) != 'undefined')
                    && (typeof(this.subjectData[fieldname].customOptions['max']) != 'undefined')) {
                    return this.subjectData[fieldname].customOptions['max'];
                }
                return false;
            },
            numberFieldStep: function(fieldname) {
                if ((typeof(this.subjectData[fieldname]) != 'undefined')
                    && (typeof(this.subjectData[fieldname].customOptions['step']) != 'undefined')) {
                    return this.subjectData[fieldname].customOptions['step'];
                }
                return false;
            },
            shouldHideField: function(fieldname) {
                let result = false;
                let conditions = this.subjectData[fieldname].hideIf;
                for (let i = 0; i < conditions.length; i++) {
                    let firstValue = this.literalOrVariableSubjectdataValue(conditions[i][0]);
                    let secondValue = this.literalOrVariableSubjectdataValue(conditions[i][2]);
                    if (((conditions[i][1] == '=') && (firstValue == secondValue))
                        || ((conditions[i][1] == '!=') && (firstValue != secondValue))
                        || ((conditions[i][1] == '<') && (firstValue < secondValue))
                        || ((conditions[i][1] == '>') && (firstValue > secondValue))) {
                        result = true;
                    }
                }

                return result;
            },
            literalOrVariableSubjectdataValue: function(value) {
                if (value === null) {
                    return value;
                }
                if ((value.toString().substr(0, 1) == '$')
                    && (typeof(this.subjectData[value.toString().substr(1)]) != 'undefined'))
                {
                    return this.subjectData[value.toString().substr(1)].value;
                }

                return value;
            },
            subjectDataForStep: function(step) {
                let result = {};
                for (var item in this.subjectData) {
                    if ((this.subjectData.hasOwnProperty(item)) && (this.subjectData[item].step == step)) {
                        result[item] = this.subjectData[item];
                    }
                }

                return result;
            },
            stepSubjectDataForGroup: function(subjectdata, group) {
                let result = {};
                Object.keys(subjectdata).forEach((key) => {
                    if (subjectdata[key].group == group) {
                        result[key] = subjectdata[key];
                    }
                });
                return result;
            },
            removeConfigFromSubjectData: function(subjectData) {
                let result = {};
                for (var item in subjectData) {
                    if ((subjectData.hasOwnProperty(item)) && (item != 'config')) {
                        result[item] = subjectData[item];
                    }
                }

                return result;
            },
            componentError: function(fieldId) {
                if (typeof(this.errors[fieldId]) != 'undefined') {
                    return this.errors[fieldId];
                }

                return [];
            },
            translate: function(string) {
                if ((typeof(window.laravelLocale) != 'undefined')
                    && (typeof(window.laravelLocales[window.laravelLocale]) != 'undefined')) {
                    if (typeof(window.laravelLocales[window.laravelLocale][string]) != 'undefined') {
                        return window.laravelLocales[window.laravelLocale][string];
                    }
                }
                if (typeof(this.$root.translate) != 'undefined') {
                    return this.$root.translate(string);
                }

                return string;
            },
            errorExists: function(fieldname) {
                return this.errors.hasOwnProperty(fieldname) && Array.isArray(this.errors[fieldname]);
            },
            isItemValid: function(fieldId) {
                let item = this.subjectData[fieldId];
                result = true;
                if ((item.mandatory) &&
                    ((item.value == null) || (item.value == -1) || (item.value == ''))) {
                    result = false;
                }
                return result;
            },
            getFormData: function() {
                this.loaded = false;
                this.$emit('edit-form-loading');
                window.axios.get(this.dataUrl, {params: this.extraUrlParameters})
                    .then((response) => {
                        this.subjectData = this.removeConfigFromSubjectData(response.data);
                        this.config = response.data.config;
                        this.currentStep = this.config.mode == 'creating' ? 1 : this.lastStep;
                        this.groups = {};
                        Object.keys(this.subjectData).forEach((key) => {
                            if (typeof(this.groups[this.subjectData[key].step]) == 'undefined') {
                                this.groups[this.subjectData[key].step] = [];
                            }
                            if (this.groups[this.subjectData[key].step].indexOf(this.subjectData[key].group) == -1) {
                                this.groups[this.subjectData[key].step].push(this.subjectData[key].group);
                                if (this.config.mode == 'creating') {
                                    this.openGroups.push(this.subjectData[key].group);
                                }
                            }
                        });
                        this.loaded = true;
                        this.dirty = false;
                        this.$emit('edit-form-loaded');
                    })
                    .catch((error) => {
                    });
            },
            updateFormData: function() {
                this.loaded = false;
                window.axios.get(this.dataUrl, {params: {subjectdata: this.stepConditionData, currentStep: this.currentStep}})
                    .then((response) => {
                        let additional = this.removeConfigFromSubjectData(response.data);
                        for (var i in additional) {
                            if (additional.hasOwnProperty(i)) {
                                Vue.set(this.subjectData, i, {...additional[i]});
                            }
                        }
                        this.loaded = true;
                        this.dirty = false;
                    })
                    .catch((error) => {
                    });
            },
            submitForm: function(closeAfterSaving) {
                closeAfterSaving = typeof(closeAfterSaving) == 'undefined' ? true : closeAfterSaving;
                this.loading = true;
                this.errors = {};
                this.$emit('submit-pending', this.formdata);
                window.axios.post(this.saveUrl, this.formdata)
                    .then((response) => {
                        if (this.currentStep != this.lastStep) {
                            this.currentStep++;
                            this.updateFormData();
                        } else {
                            if (typeof(this.successCallback) != 'undefined') {
                                window[this.successCallback]();
                            }
                            if (closeAfterSaving) {
                                this.$emit('submit-success', response.data);
                                if (this.redirectToResponseOnSuccess == 'true') {
                                    window.location.href = response.data;
                                }
                            }
                            this.resultMessage = this.showResponseMessage
                                ? response.data
                                : this.translate('Changes saved');
                            this.resultMessageClass = 'alert-success';
                            setTimeout(() => {this.resultMessage = ''}, 3000);
                        }
                        this.loading = false;
                    })
                    .catch((error) => {
                        if (error.response.status == 422) {
                            this.errors = error.response.data.errors;
                        }
                        if (error.response.status != 422) {
                            if (error.response.status == 500) {
                                alert(error.response.data.message);
                            }
                            if (error.response.status == 419) {
                                this.resultMessage = error.response.data.message;
                                this.resultMessageClass = 'alert-danger';
                                setTimeout(() => {this.resultMessage = ''}, 6000);
                            }
                        }
                        this.loading = false;
                    });
            },
            cancelEditing: function() {
                this.errors = {};
                this.subjectData = {};
                this.$emit('editing-canceled');
                if (typeof(this.redirectToOnCancel) != 'undefined') {
                    window.location.href = this.redirectToOnCancel;
                }
            },
            slugify: function(string) {
                //credit to https://medium.com/@mhagemann/the-ultimate-way-to-slugify-a-url-string-in-javascript-b8e4a0d849e1
                const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôőœṕŕßśșțùúüûǘűẃẍÿź·/_,:;'
                const b = 'aaaaaaaaceeeeghiiiimnnnooooooprssstuuuuuuwxyz------'
                const p = new RegExp(a.split('').join('|'), 'g')
                return string.toString().toLowerCase()
                    .replace(/\s+/g, '-') // Replace spaces with -
                    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
                    .replace(/&/g, '-and-') // Replace & with ‘and’
                    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
                    .replace(/\-\-+/g, '-') // Replace multiple - with single -
                    .replace(/^-+/, '') // Trim - from start of text
                    .replace(/-+$/, '') // Trim - from end of text
            },
            generateSlug: function(fields, fieldname) {
                let sourceText = '';
                fields.forEach((field) => {
                    if (this.subjectData[field].kind == 'select') {
                        sourceText = sourceText + this.subjectData[field].valueset[this.subjectData[field].value] + ' ';
                    } else {
                        sourceText = sourceText + this.subjectData[field].value + ' ';
                    }
                })

                this.subjectData[fieldname].value = this.slugify(sourceText.trim());
            },
            toggleGroupVisibility: function(group) {
                if (this.openGroups.indexOf(group) == -1) {
                    this.openGroups.push(group);
                } else {
                    this.openGroups = this.openGroups.filter((item) => {
                        return item != group;
                    });
                }
            }
        },
        watch: {
            subjectData: function() {
                this.dirty = true;
            },
            rootShowInPlaceEditor: function() {
                if (this.rootShowInPlaceEditor)  {
                    this.getFormData();
                }
            },
            parentShowInPlaceEditor: function() {
                if (this.parentShowInPlaceEditor)  {
                    this.getFormData();
                }
            }
        }
    }
</script>
<style>
    .disabled-overlay {
        position: absolute;
        top: -2px;
        left: -2px;
        width: 101%;
        height: 101%;
        z-index: 100;
        background-color: rgba(210, 210, 210, .2);
    }
    h4.form-step-header {
        margin-top:20px;
        margin-left:-5px;
        margin-right:-5px;
        border-top: 2px solid lightgrey;
        border-left: 1px solid lightgrey;
        padding: 5px;
    }
    .vuecrud-caret {
        transition: transform 200ms ease-in-out;
        transform-origin: center;
    }
    .vuecrud-caret.open {
        transform: rotate(-90deg);
    }
</style>
